import React from 'react'
import { MarkerClusterer } from './markerClusterer'
import './CustomerMap.css'

const google = window.google

const centreOfMap = new google.maps.LatLng(-28.903653, 142.46519)
const fullScreenChangeEvents = [
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'fullscreenchange',
]

class CustomerMap extends React.Component {
    componentDidMount() {
        this.map = new google.maps.Map(document.getElementById('map'), {
            zoom: 3,
            center: centreOfMap,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            streetViewControl: false,
            maxZoom: 14,
            mapTypeControl: false,
            fullscreenControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_RIGHT,
            },
        })

        this.refreshMap(this.props.data, this.props.event)

        fullScreenChangeEvents.forEach(e => {
            document.addEventListener(e, this.centerMap)
        })
    }

    componentWillUpdate(nextProps) {
        const { data, event } = nextProps
        if (data !== this.props.data) {
            this.refreshMap(data, event)
        }
    }

    componentWillUnmount() {
        fullScreenChangeEvents.forEach(e => {
            document.removeEventListener(e, this.centerMap)
        })
    }

    map = null
    markerClusterer = null
    mapId = null

    refreshMap = (data, event) => {
        const isValidLocation = location => {
            if (location.latitude == null) return false
            if (location.longitude == null) return false
            // eslint-disable-next-line
            if (location.latitude == 0 && location.longitude == 0) return false
            return true
        }

        const addVenueMarker = () => {
            const { venueName, venueLatitude, venueLongitude } = event

            const icon = {
                url: 'http://maps.google.com/mapfiles/kml/paddle/wht-stars.png', // url
                scaledSize: new google.maps.Size(35, 35), // scaled size
            }

            // eslint-disable-next-line
            new google.maps.Marker({
                position: new google.maps.LatLng(venueLatitude, venueLongitude),
                map: this.map,
                title: venueName,
                icon,
            })
        }

        if (this.markerClusterer) {
            this.markerClusterer.clearMarkers()
        }

        const positions = data
            .filter(isValidLocation)
            .map(d => new google.maps.LatLng(d.latitude, d.longitude))

        const markers = positions.map(
            p => new google.maps.Marker({ position: p }),
        )

        addVenueMarker()

        this.markerClusterer = new MarkerClusterer(this.map, markers, {
            imagePath: '/m',
            minimumClusterSize: 1,
        })
    }

    centerMap = () => {
        requestAnimationFrame(() => {
            this.map.setCenter(centreOfMap)
        })
    }

    render() {
        return (
            <div id="map-container">
                <div id="map" ref={this.mapRef} />
            </div>
        )
    }
}

export default CustomerMap
